import React from 'react';
import Header from '../../components/Header/Header';
import samplesData from './samples.json'; 
import Footer from '../../components/Footer/Footer'

const performance = () => {
  const { samples } = samplesData;

  return (
    <>
      <Header />
      <div className="min-h-screen bg-[#fafafd] py-10 px-2 sm:px-6 lg:px-24">
        <h1 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-800">
          Evaluating the performance of our translation service 
        </h1>
        <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
          We provide below some samples of how translate.paralegal.lk compares with Google Translate and against official legislation translations.
        </p>
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {samples.map((sample) => (
            <div
              key={sample.id}
              className="bg-white rounded-xl shadow p-6 md:p-8 border border-gray-200"
            >
              <div className="mb-4">
                <span className="block text-xs font-semibold text-gray-400 mb-1">
                  {sample.source_language === 'en'
                    ? 'English'
                    : sample.source_language === 'ta'
                      ? 'Tamil'
                      : 'Sinhala'}
                </span>
                <p className="text-gray-900 font-medium">
                  {sample.source_text}
                </p>
              </div>

              {Object.entries(sample.translations).map(
                ([targetLang, providers]) => (
                  <div
                    key={targetLang}
                    className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4"
                  >
                    <div>
                      <span className="block text-xs font-semibold text-pink-600 mb-1">
                        translate.paralegal.lk (
                        {targetLang === 'en'
                          ? 'English'
                          : targetLang === 'ta'
                            ? 'Tamil'
                            : 'Sinhala'}
                        )
                      </span>
                      <p className="text-gray-700 text-sm bg-pink-50 rounded px-2 py-1">
                        {providers['translate.paralegal.lk']}
                      </p>
                    </div>
                    <div>
                      <span className="block text-xs font-semibold text-gray-500 mb-1">
                        Google Translate (
                        {targetLang === 'en'
                          ? 'English'
                          : targetLang === 'ta'
                            ? 'Tamil'
                            : 'Sinhala'}
                        )
                      </span>
                      <p className="text-gray-700 text-sm bg-gray-100 rounded px-2 py-1">
                        {providers.google}
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default performance;
